import { Injectable } from '@angular/core';
import { StereoAudioRecorder } from 'recordrtc';
import { Subscription, timer } from 'rxjs';

const MaxTime = 60;
@Injectable()
export class AudioRecordingService {
  private _audioEngine = new Audio();
  private _recording = false;
  // FIXME: type not exist for StereoAudioRecorder
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private _recorder: any;
  private _timeLeft = MaxTime;
  public time: number;
  private _subscribeTimer: Subscription;

  constructor() {
    this._audioEngine.src = './assets/sounds/recording.wav';
    this._audioEngine.load();
  }

  public get recording() {
    return this._recording;
  }

  public get remainingTime() {
    const zeroPad = (num: number, places: number) =>
      String(num).padStart(places, '0');

    return `00:${zeroPad(this.time, 2)}`;
  }

  private playSound(): Promise<void> {
    return new Promise((resolve) => {
      this._audioEngine.currentTime = 0;
      this._audioEngine.play();
      this._audioEngine.onended = () => {
        resolve();
      };
    });
  }

  private resetTimer() {
    this._subscribeTimer?.unsubscribe();
    this._timeLeft = MaxTime;
  }

  public startTimer(): Promise<void> {
    this.resetTimer();
    return new Promise((resolve) => {
      this._subscribeTimer = timer(0, 1000).subscribe((val) => {
        this.time = this._timeLeft - val;
        if (this.time <= 0) {
          resolve();
        }
      });
    });
  }

  public async startRecording() {
    await this.playSound();

    this._recording = true;
    const mediaConstraints = {
      video: false,
      audio: true,
    };

    try {
      const stream = await navigator.mediaDevices.getUserMedia(
        mediaConstraints,
      );

      const options = {
        mimeType: 'audio/mp3',
        numberOfAudioChannels: 1,
      };

      this.record(stream, options);
    } catch (error) {
      await this.stopRecording();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public record(mediaStream: MediaStream, config: any) {
    this._recorder = new StereoAudioRecorder(mediaStream, config);
    this._recorder.record();
  }

  public async stopRecording(): Promise<Blob> {
    this._recording = false;
    this.resetTimer();

    return new Promise((resolve, reject) => {
      this._recorder?.stop((blob: Blob) => {
        if (!blob) reject();

        this.playSound();
        resolve(blob);
      });
    });
  }
}
